import { createFromIconfontCN } from '@ant-design/icons';
export default createFromIconfontCN({
  scriptUrl: '//at.alicdn.com/t/c/font_3539518_mkjyplvaare.js'
});
